import React from 'react';
import PropTypes from 'prop-types';

const Keys = ( {
    goalPaceLabel,
    trendingKeyLabel,
    progressKeyLabel,
    showTrend,
    calculationType,
    style
} ) => (
    <div className="keys" style={ style }>
        <div className="key goal-pace">
            <svg height="10" width="40">
                <line stroke="#cecece" strokeWidth="10" x1="0" y1="5" x2="40" y2="5" className="progress-line-key" />
            </svg>
            <span className="key-label">{ goalPaceLabel }</span>
        </div>
        { showTrend &&
            <div className="key trending">
                <svg height="10" width="40">
                    <line stroke="#353a40" strokeWidth="10" strokeDasharray="10, 3" x1="0" y1="5" x2="38" y2="5" className="trend-line-key" />
                </svg>
                <span className="key-label">{ trendingKeyLabel }</span>
            </div>
        }
        { calculationType !== 'average' &&
            <div className="key progress">
                <svg height="10" width="40">
                    <line stroke="#353a40" strokeWidth="10" x1="0" y1="5" x2="40" y2="5" className="goal-line-key" />
                </svg>
                <span className="key-label">{ progressKeyLabel }</span>
            </div>
        }
    </div>
);

Keys.propTypes = {
    goalPaceLabel: PropTypes.string.isRequired,
    trendingKeyLabel: PropTypes.string.isRequired,
    progressKeyLabel: PropTypes.string.isRequired,
    showTrend: PropTypes.bool,
    calculationType: PropTypes.string.isRequired,
    style: PropTypes.object
};

export default Keys;
